import { oncallFetch } from "sc/backend/oncall/fetch-helper";

export default function*(id) {
  return yield oncallFetch("/api/oncall/administration/partners/get-by-id", {
    id,
  });
}



// WEBPACK FOOTER //
// ./src/sc/backend/oncall/administration/partners/get-by-id.js